<template>
  <section class="container mt-4" aria-labelledby="about-heading">
    <div class="row about_row">
      <div class="col-md-12">
        <h1 id="about-heading" class="page-title mb-4">About Grow With Stocks</h1>
      </div>
    </div>
    <div class="row about_row">
      <div class="col-md-6 col-sm-6 col-xs-12 visible-xs">
        <img
          src="../assets/Mission.png"
          class="img-responsive"
          alt=""
        >
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12">
        <h2>Our mission</h2>
        <p>To give retail investor the necessary tools, guidance and confidence so that they can be in the best position to perform a lot better than the so called fund managers and make a killing over long term.</p>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12 hidden-xs">
        <img
          src="../assets/Mission.png"
          class="img-responsive"
          alt=""
        >
      </div>
    </div>
    <div class="row about_row">
      <div class="col-md-6 col-sm-6 col-xs-12">
        <img
          src="../assets/Vision.png"
          class="img-responsive"
          id="vision_image"
          alt=""
        >
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12">
        <h2>Our Vision</h2>
        <p>With less than 2 % population of India investing in securities (which is very low compared to USA and China though we are one of the fastest growing economies), the power of wealth creation through stock market is highly unexplored by Indian population specially the working class. Unfortunately, the majority of people are unaware and have misconceptions about stock market and see investing in stocks as intimidating.
        </p>
      </div>
    </div>
    <div class="row about_row">
      <div class="col-md-12 col-sm-12 col-xs-12 qoute_container">
        <blockquote class="lead-quote">We intend to change the dogma attached with investing in stocks and enable more and more people to take advantage of this huge opportunity offered by Indian market over the next 10 to 20 years.</blockquote>
      </div>
    </div>
    <div class="row about_row">
      <div class="col-md-6 col-sm-6 col-xs-6 col-xs-offset-3 visible-xs">
        <img
          src="../assets/gws founder copy.jpg"
          class="img-responsive img-circle founder"
          alt="Goutam Sharma, Founder of Grow With Stocks"
        >
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12">
        <h2>About the firm</h2>
        <p>We are a stock research and advisory firm that help people become better investors by providing them with the best in class stock recommendations along with the easy to understand detailed analysis report.
        </p>
        <p>Grow With Stocks was founded by Goutam Sharma (Sebi registered - INH000001212) in 2011 in order to serve the retail/individual investors and guide them towards financial freedom through investing in stocks.</p>
      </div>
      <div class="col-md-3 col-md-offset-2 col-sm-offset-2 col-sm-3 col-xs-12 hidden-xs">
        <img
          src="../assets/gws founder copy.jpg"
          class="img-responsive img-circle founder"
          alt="Goutam Sharma, Founder of Grow With Stocks"
        >
      </div>
    </div>
    <div class="row about_row">
      <div class="col-md-6 col-sm-6 col-xs-12">
        <img
          src="../assets/Stock Research Company.png"
          class="img-responsive"
          id="research_image"
          alt=""
        >
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12">
        <h2>Why we exist</h2>
        <p class="mt-5">We realised that too many people buy stocks only based on news hype, random tips from friends/family or brokers because it is too complicated and time consuming for them to do proper research. And therefore, they end up either losing money or getting mediocre returns.
        </p>
      </div>
    </div>
    <div class="row about_row qoute_container">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <blockquote class="lead-quote">Whether you are a newbie or an experienced investor, there is always a room to improve and become a better investor. We believe that anyone can do it even if they don’t have a lot of money or time.</blockquote>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "About",
    mounted() {
      document.title = "About Us | Grow With Stocks";
    }
  };
</script>

<style lang="scss" scoped>
  .heading_bdr_btm {
    padding-bottom: 5px;
    border-bottom: 3px #1a7055 solid;
  }
  .page-title {
    font-size: 40px;
    font-weight: 800;
    text-align: center;
    color: #1a1a1a;
    letter-spacing: -0.5px;
    margin-top: 24px;
    position: relative;
    padding-bottom: 16px;
  }
  .page-title::after {
    content: "";
    display: block;
    width: 64px;
    height: 4px;
    background: #1a7055;
    border-radius: 2px;
    margin: 16px auto 0;
  }
  p {
    font-size: 18px;
    font-weight: 400;
    line-height: 30px;
    color: #444;
  }
  .about_row {
    padding: 64px 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .about_row + .about_row {
    border-top: 1px solid #ececec;
  }
  .about_row img.img-responsive:not(.founder) {
    border-radius: 12px;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.06);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  .about_row img.img-responsive:not(.founder):hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.10);
  }
  @media (prefers-reduced-motion: reduce) {
    .about_row img.img-responsive:not(.founder),
    .about_row img.img-responsive:not(.founder):hover {
      transition: none;
      transform: none;
    }
  }
  .qoute_container {
    text-align: center;
    padding: 48px 0;
    background: linear-gradient(180deg, #fafafa 0%, #f3f6f4 100%);
    border-radius: 12px;
    margin: 32px 0;
  }
  .lead-quote {
    font-size: 22px;
    font-weight: 500;
    line-height: 34px;
    font-style: italic;
    color: #2d2d2d;
    border-left: 4px solid #1a7055;
    padding: 12px 24px;
    margin: 0 auto;
    max-width: 900px;
    text-align: left;
    position: relative;
  }
  .lead-quote::before {
    /* Decorative oversized quote mark: empty alt ("/ \"\"") so SR doesn't announce the “ */
    content: "\201C" / "";
    font-family: Georgia, serif;
    font-size: 64px;
    color: #1a7055;
    line-height: 1;
    position: absolute;
    top: -12px;
    left: 12px;
    opacity: 0.18;
  }
  h2 {
    font-size: 26px;
    font-weight: 700;
    line-height: 32px;
    color: #1a1a1a;
    margin-bottom: 16px;
    position: relative;
    padding-bottom: 10px;
  }
  h2::after {
    content: "";
    display: block;
    width: 40px;
    height: 3px;
    background: #1a7055;
    border-radius: 2px;
    margin-top: 10px;
  }
  .founder {
    width: 85%;
    border: 4px solid #fff;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  }
  /*==========  Mobile First Method  ==========*/

  /* Custom, iPhone Retina */
  @media only screen and (min-width: 320px) and (max-width: 1024px) {
    p {
      font-size: 15px;
      font-weight: 400;
      line-height: 26px;
    }
    h2 {
      font-size: 20px;
      font-weight: 700;
      line-height: 28px;
    }
    .qoute_container {
      text-align: center;
      padding: 32px 16px;
    }
  }

  /* Extra Small Devices, Phones */
  @media only screen and (min-width: 480px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (min-width: 768px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (min-width: 992px) {
  }

  /* Large Devices, Wide Screens */
  @media only screen and (min-width: 1200px) {
  }

  /*==========  Non-Mobile First Method  ==========*/

  /* Large Devices, Wide Screens */
  @media only screen and (max-width: 1200px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width: 992px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (max-width: 768px) {
  }

  /* Custom, iPhone Retina */
  @media only screen and (max-width: 320px) {
  }

  @media only screen and (max-width: 768px) {
    .about_row {
      padding: 40px 0;
    }
    .founder {
      margin: 20px 0;
    }
    .page-title {
      font-size: 30px;
    }
  }
  /* Extra Small Devices, Phones */
  @media only screen and (max-width: 480px) {
    h2 {
      font-size: 20px;
    }
    .founder {
      margin: 20px 0;
      width: 60%;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
    .page-title {
      font-size: 26px;
    }
    .lead-quote {
      font-size: 18px;
      line-height: 28px;
      padding: 8px 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/About.vue